module.exports = {
      id: "heroicons-speakerphone-usage",
      viewBox: "0 0 24 24",
      url: "/assets/icons/" + "sprite.ecb5ac98d0f5af61574884cef75bbacd.svg#heroicons-speakerphone",
      toString: function () {
        return this.url;
      }
    }